"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _UICloseButton = _interopRequireDefault(require("UIComponents/button/UICloseButton"));

var _UIModal = _interopRequireDefault(require("UIComponents/dialog/UIModal"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var _getFeatureDescriptionKey = _interopRequireDefault(require("self-service-api/core/utilities/getFeatureDescriptionKey"));

var _colors = require("HubStyleTokens/colors");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  font-size: 16px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  flex-grow: 1;\n  font-size: 20px;\n  font-weight: 600;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  background-color: ", ";\n  height: 70px;\n  width: 100%;\n  border-bottom: 1px solid ", ";\n  display: flex;\n  align-items: center;\n  padding-left: 40px;\n  padding-right: 20px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  padding: 40px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var ModalBodyContainer = _styledComponents.default.div.withConfig({
  displayName: "FeaturesModal__ModalBodyContainer",
  componentId: "kue60i-0"
})(_templateObject());

var ModalHeaderContainer = _styledComponents.default.div.withConfig({
  displayName: "FeaturesModal__ModalHeaderContainer",
  componentId: "kue60i-1"
})(_templateObject2(), _colors.GYPSUM, _colors.KOALA);

var ModalHeader = _styledComponents.default.div.withConfig({
  displayName: "FeaturesModal__ModalHeader",
  componentId: "kue60i-2"
})(_templateObject3());

var FeatureText = (0, _styledComponents.default)(_FormattedMessage.default).withConfig({
  displayName: "FeaturesModal__FeatureText",
  componentId: "kue60i-3"
})(_templateObject4());

var FeaturesModal = function FeaturesModal(_ref) {
  var header = _ref.header,
      features = _ref.features,
      onModalClose = _ref.onModalClose,
      hubType = _ref.hubType;
  return _react.default.createElement(_UIModal.default, null, _react.default.createElement(ModalHeaderContainer, null, _react.default.createElement(ModalHeader, null, header), _react.default.createElement(_UICloseButton.default, {
    color: _colors.OBSIDIAN,
    onClick: onModalClose
  })), _react.default.createElement(ModalBodyContainer, null, Object.keys(features).map(function (key) {
    return _react.default.createElement("div", {
      key: key,
      className: "m-bottom-5"
    }, _react.default.createElement(_UIIcon.default, {
      name: "success",
      className: "m-right-4"
    }), _react.default.createElement(_UITooltip.default, {
      placement: "right",
      title: _react.default.createElement(_FormattedMessage.default, {
        message: (0, _getFeatureDescriptionKey.default)(key, hubType)
      })
    }, _react.default.createElement("div", {
      style: {
        display: 'inline-block'
      }
    }, _react.default.createElement(FeatureText, {
      message: "pricing-pages.features." + key + ".name"
    }))));
  })));
};

var _default = FeaturesModal;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/free-tools-page/FeaturesModal.js
// module id = 581
// module chunks = 5 6